import axios from "axios";

const API_URL = "https://srinivasafleet.com/api";

const authHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    localStorage.getItem("access_token");

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
};

export const getStaff = async (params = {}) => {
  const response = await axios.get(
    `${API_URL}/staff/`,
    {
      params,
      headers: authHeaders(),
    }
  );

  return response.data;
};

export const createStaff = async (data) => {
  const response = await axios.post(
    `${API_URL}/staff/`,
    data,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const getStaffById = async (id) => {
  const response = await axios.get(
    `${API_URL}/staff/${id}`,
    {
      headers: authHeaders(),
    }
  );

  return response.data;
};

export const getServiceLocations = async () => {
  const response = await axios.get(
    `${API_URL}/staff/service-locations/all`,
    {
      headers: authHeaders(),
    }
  );

  return response.data;
};

export const updateStaff = async (
  id,
  data
) => {
  const response = await axios.put(
    `${API_URL}/staff/${id}`,
    data,
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const deleteStaff = async (id) => {
  const response = await axios.delete(
    `${API_URL}/staff/${id}`,
    {
      headers: authHeaders(),
    }
  );

  return response.data;
};

export const changeStaffStatus = async (
  id,
  status
) => {
  const response = await axios.put(
    `${API_URL}/staff/${id}/status`,
    {
      status,
    },
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const resetStaffPassword = async (
  id,
  password,
  confirm_password
) => {
  const response = await axios.put(
    `${API_URL}/staff/${id}/reset-password`,
    {
      password,
      confirm_password,
    },
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};

export const getRoles = async () => {
  const response = await axios.get(
    `${API_URL}/staff/roles/all`,
    {
      headers: authHeaders(),
    }
  );

  return response.data;
};

export const getBranches = async () => {
  const response = await axios.get(
    `${API_URL}/drivers/master-branch`,
    {
      headers: authHeaders(),
    }
  );

  return response.data;
};


/* =========================================================
   STAFF MOBILE OTP
   ========================================================= */

export const sendStaffOtp = async (
  mobile
) => {
  const response = await axios.post(
    `${API_URL}/staff/send-otp`,
    {
      mobile,
    },
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};


export const verifyStaffOtp = async (
  mobile,
  otp,
  verification_id
) => {
  const response = await axios.post(
    `${API_URL}/staff/verify-otp`,
    {
      mobile,
      otp,
      verification_id,
    },
    {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
};


/* =========================================================
   CURRENT USER
   ========================================================= */

export const getCurrentUser = () => {
  let permissions = {};

  try {
    permissions = JSON.parse(
      localStorage.getItem("permissions") ||
        "{}"
    );
  } catch {
    permissions = {};
  }

  return {
    user_id:
      localStorage.getItem("user_id"),

    role_id:
      localStorage.getItem("role_id"),

    role_name:
      localStorage.getItem("role_name"),

    full_name:
      localStorage.getItem("full_name"),

    mobile:
      localStorage.getItem("mobile"),

    permissions,

    financial_year_id:
      localStorage.getItem(
        "financial_year_id"
      ) || null,

    financial_year_label:
      localStorage.getItem(
        "financial_year_label"
      ) || "",
  };
};


/* =========================================================
   LOGOUT
   ========================================================= */

export const logoutUser = () => {
  localStorage.clear();
};


/* =========================================================
   STAFF PHOTO
   ========================================================= */

export const uploadStaffPhoto = async (
  file
) => {
  const formData = new FormData();

  formData.append(
    "file",
    file
  );

  const response = await axios.post(
    `${API_URL}/staff/upload-photo`,
    formData,
    {
      headers: {
        ...authHeaders(),
        "Content-Type":
          "multipart/form-data",
      },
    }
  );

  return response.data;
};